'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTheme = require('@narvar/nth-hook-theme');
var useFormatEddQuery = require('@narvar/nth-hook-format-edd');
var utils = require('../utils.js');
var Icons = require('./Icons.js');
var Status_module = require('./Status.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useFormatEddQuery__default = /*#__PURE__*/_interopDefaultLegacy(useFormatEddQuery);

const Status = props => {
  const {
    displayDate,
    displayDateRange,
    featureName
  } = props;
  const {
    blockDeliveryStatusEtaText,
    trackingStatus
  } = nthHookTranslations.useTranslations();
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  const eddFormatTranslationKeys = [{
    sameDay: 'blockDeliveryStatusEtaFormattedTime',
    lastDay: 'blockDeliveryStatusEtaFormattedTime',
    nextDay: 'blockDeliveryStatusEtaFormattedTime',
    lastWeek: 'blockDeliveryStatusEtaFormattedTime',
    nextWeek: 'blockDeliveryStatusEtaFormattedTime',
    sameElse: 'blockDeliveryStatusEtaFormattedTime'
  }];
  const {
    data
  } = useFormatEddQuery__default["default"]({
    eddCombos: [{
      displayDate,
      eddFormatTranslationKeys,
      dateOnly: false
    }, {
      displayDate: displayDateRange?.begin || '',
      eddFormatTranslationKeys,
      dateOnly: false
    }, {
      displayDate: displayDateRange?.end || '',
      eddFormatTranslationKeys,
      dateOnly: false
    }]
  });
  if (!data) return null;
  const [displayDateFormatted, displayDateRangeBeginFormatted, displayDateRangeEndFormatted] = data.formatEdd.formattedEdds;
  const trackingStatusText = utils.renderTemplate(trackingStatus ?? '', {
    arrival: {
      minutes: '28'
    }
  });
  const eta = utils.renderTemplate(blockDeliveryStatusEtaText ?? '', {
    arrival: {
      begin: displayDateRangeBeginFormatted[0],
      end: displayDateRangeEndFormatted[0],
      time: displayDateFormatted[0]
    },
    delivery: {
      time: displayDateFormatted[0]
    },
    pickup: {
      begin: displayDateRangeBeginFormatted[0],
      end: displayDateRangeEndFormatted[0],
      time: displayDateFormatted[0]
    }
  });
  const showETA = displayDateFormatted[0] || displayDateRangeBeginFormatted[0] || displayDateRangeEndFormatted[0];
  return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, {
    as: "h2",
    featureName: featureName
  }, trackingStatusText), showETA && /*#__PURE__*/React__default["default"].createElement("div", {
    className: Status_module["default"].eddContainer
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Status_module["default"].clockIcon
  }, /*#__PURE__*/React__default["default"].createElement(Icons.Clock, null)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: Status_module["default"].statusText
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      ...bodytextDefaultNone
    }
  }, eta))));
};
var Status$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(Status, {
  themeTokens: ['bodytextDefaultNone']
}), {
  translationKeys: ['blockDeliveryStatusEtaText', 'trackingStatus']
});

exports["default"] = Status$1;
